import { useState, useEffect } from 'react'
import classNames from 'classnames'
import { IoIosMenu } from 'react-icons/io'
import { IconContext } from 'react-icons'
import { AiOutlineSearch } from 'react-icons/ai'
import { useRouter } from 'next/router'
import Link from 'next/link'
import Highlighter from 'react-highlight-words'
import useSearchSpeakersByTextService from '@/hooks/useSearchSpeakersByTextService'
import Loader from '@/components/common/Loader'
import Button from '@/components/common/Button'
import TextInput from '@/components/common/TextInput'
import MyProfile from '@/components/speaker/MyProfile'
import Modal from '@/components/common/MobileMenuModal'
import { useDispatch } from 'react-redux'
import { setFilters } from '@/store/slices/speakersSlice'
import { IoCloseSharp } from 'react-icons/io5'
import { useMsal } from '@azure/msal-react'
import { ChatContext } from '@/pages/_app'
import React, { useContext } from 'react'
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react'

const HeaderMobileView = () => {
  const toggleChat = useContext(ChatContext)
  const { instance } = useMsal()
  const router = useRouter()
  const dispatch = useDispatch()
  const [searchText, setSearchText] = useState('')
  const [viewText, setViewText] = useState('')
  const [suggestions, setSuggestions] = useState([])
  const [show, setShow] = useState(false)
  const [speakersDetails, setSpeakersDetails] = useState([])
  const [error, setError] = useState('')
  const [isChatOpen, setIsChatOpen] = useState(false)
  const [isPopup, setIsPopup] = useState(false)

  const { data, isLoading, isError } = useSearchSpeakersByTextService(
    searchText.length >= 2 ? { text: searchText.toLowerCase() } : { text: '' }
  )

  useEffect(() => {
    if (data !== null || data !== undefined) {
      setSpeakersDetails(data)
    }
  }, [data])

  useEffect(() => {
    if (
      searchText == '' ||
      suggestions.length == 0 ||
      (suggestions?.NameList?.length == 0 &&
        suggestions?.CategoryList?.length == 0 &&
        suggestions?.SpeakerTypeList.length == 0)
    ) {
      setShow(false)
      return
    }
    setShow(true)
  }, [
    searchText,
    suggestions,
    suggestions?.NameList,
    suggestions?.CategoryList,
    suggestions?.SpeakerTypeList,
  ])

  useEffect(() => {
    setSearchText('')
    setSuggestions([])
    setViewText('')
    setError('Enter at least 2 characters to search')
  }, [])

  useEffect(() => {
    if (searchText.length >= 2 && validateInput(searchText)) {
      if (speakersDetails) setSuggestions(getSuggestions(searchText))
      setError('')
      return
    }
    setSuggestions([])
  }, [searchText, speakersDetails])

  const MouseOver = (category) => {
    if (searchText.length >= 2) {
      setViewText(category)
      return
    }
    setViewText('')
  }

  const MouseOut = () => {
    setViewText('')
  }

  const onInputChange = (e) => {
    viewText ? setViewText('') : ''
    setSearchText(e.target.value)
    validateInput(e.target.value)
  }

  const getSuggestions = (value) => {
    const searchInput = value && value.trim().toLowerCase()
    const searchInputLength = searchInput.length

    const NameList = speakersDetails.map((i) => {
      if (speakersDetails.length > 0 && i?.contentType == 'speaker') {
        const result = {
          name: i?.name,
          image_url: i?.assets?.fields?.file?.url,
          slug: i?.slug,
        }
        return result
      }
    })

    const CategoryList = speakersDetails?.map((i) => {
      if (speakersDetails.length > 0 && i?.contentType == 'speakerTopic') {
        const result = {
          id: i?.id,
          category: i?.name && i?.name,
          slug: i?.slug && i?.slug,
        }
        return result
      }
    })

    const SpeakerTypeList = speakersDetails?.map((i) => {
      if (speakersDetails.length > 0 && i?.contentType == 'speakerTypes') {
        const result = {
          id: i?.id,
          type: i?.name,
          slug: i?.slug && i?.slug,
        }
        return result
      }
    })

    const result = {
      NameList: NameList,
      CategoryList: CategoryList?.filter((i) => i),
      SpeakerTypeList: SpeakerTypeList.filter((i) => i),
    }

    return searchInputLength === 0 ? [] : result
  }

  const validateInput = (text) => {
    if (text.length == 1 || text.length == 0) {
      setError('Enter at least 2 characters to search')
      return false
    } else {
      return true
    }
  }

  const onCategoryClick = (topic) => {
    router.push({
      pathname: `/speakers/topics/${topic?.slug}`,
    })
  }
  const onTypeClick = (speakertype) => {
    router.push({
      pathname: `/speakers/types/${speakertype?.slug}`,
    })
  }

  const handleSignout = async () => {
    localStorage.clear()
    sessionStorage.clear()
    localStorage.setItem('logout-event', 'started')
    localStorage.removeItem('logout-event')
    await instance.logoutRedirect()
  }

  const showOverflow = () => {
    const scrollPosition = window.pageYOffset
    document.querySelector('body').style.removeProperty('overflow')
    document.querySelector('body').style.removeProperty('position')
    document.querySelector('body').style.removeProperty('top')
    document.querySelector('body').style.removeProperty('width')
    window.scrollTo(0, scrollPosition)
  }

  const hidden = () => {
    const scrollPosition = window.pageYOffset
    document.querySelector('body').style.overflow = 'hidden'
    document.querySelector('body').style.position = 'fixed'
    document.querySelector('body').style.top = `-${scrollPosition}px`
    document.querySelector('body').style.width = '100%'
  }
  const onSearchRedirect = () => {
    if (validateInput(searchText) && searchText.length >= 2) {
      setError('')
      setViewText('')
      dispatch(
        setFilters({
          categories: null,
          searchQuery: '',
          types: null,
          profileCategory: null,
          relatedSpeakers: null,
          sortOrder: null,
        })
      )
      router.push({
        pathname: '/speakers',
        query: { query: searchText.trim() },
      })
      return
    }
    setViewText('')
    return
  }

  return (
    <div className={classNames(isChatOpen ? 'z-[50]' : 'z-[21474836461]')}>
      {isPopup ? (
        <IoCloseSharp
          className="w-8 text-5xl"
          onClick={() => {
            setIsChatOpen(false)
            setIsPopup(false)
          }}
        />
      ) : (
        <IoIosMenu
          className="w-8 text-5xl"
          onClick={() => {
            setIsPopup(true)
            setIsChatOpen(false)
            hidden()
            window.scrollTo(0, 0)
          }}
        />
      )}
      {isPopup && (
        <Modal
          isShow={isPopup}
          zIndex={isChatOpen ? 'z-50' : 'z-[21474836461]'}
          body={
            <>
              <div
                className={
                  suggestions?.CategoryList?.length > 0 || suggestions?.NameList?.length > 0
                    ? 'sm:w-full mb-52 h-full'
                    : 'sm:w-full mb-6 h-full'
                }
              >
                <div className="relative block bg-black cursor-pointer md:hidden">
                  <div tabIndex={0}></div>
                  <TextInput
                    tabindex="-1"
                    className="w-full h-12 pl-4 pr-16 bg-black border-b-2 rounded-sm border-custom-gray-80 placeholder:text-sm placeholder:text-white placeholder:font-thin focus:outline-none"
                    placeHolder="Search by Speaker Name, Topic, or Type"
                    value={viewText ? viewText : searchText}
                    onKeyPress={(event) => {
                      if (
                        event.key === 'Enter' ||
                        event.key === 'NumpadEnter' ||
                        event.keyCode === 13 ||
                        event.code === 'Return'
                      ) {
                        onSearchRedirect()
                        setIsPopup(false)
                        showOverflow()
                      }
                    }}
                    onChange={onInputChange}
                  />

                  <span
                    className="absolute inset-y-0 right-0 flex items-center pr-4"
                    onClick={() => {
                      onSearchRedirect()
                      setIsPopup(false)
                      showOverflow()
                    }}
                  >
                    <IconContext.Provider
                      value={{
                        size: '1.8em',
                        color: '#ffffff',
                      }}
                    >
                      <AiOutlineSearch />
                    </IconContext.Provider>
                  </span>
                </div>
                <div>
                  <div
                    className={`${
                      show ? 'relative m-auto px-4' : 'relative m-auto md:mb-14 mt-2.5  px-4'
                    }`}
                  >
                    <span className="text-sm font-normal leading-7 regular-font">
                      {error == '' ? '' : error}
                    </span>
                    {isError || (speakersDetails?.length == 0 && searchText.length >= 2) ? (
                      <span className="text-lg regular-font font-normal leading-7">
                        No speakers match your search criteria
                      </span>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className="relative mt-4">
                    {show ? (
                      <>
                        {isLoading ? (
                          <Loader />
                        ) : (
                          <div className="w-full text-white">
                            {suggestions?.SpeakerTypeList &&
                              suggestions?.SpeakerTypeList?.slice(0, 4).map((item, i) => (
                                <div key={i} className="flex md:gap-6">
                                  <div className="w-full text-xl font-thin leading-loose bg-black hover:bg-opacity-20 hover:bg-gray-200">
                                    <a
                                      className="cursor-pointer"
                                      onClick={() => {
                                        dispatch(
                                          setFilters({
                                            categories: null,
                                            searchQuery: '',
                                            types: [item?.id],
                                            profileCategory: null,
                                            relatedSpeakers: null,
                                            sortOrder: null,
                                          })
                                        ),
                                          setIsPopup(false)
                                        setSearchText(''),
                                          setViewText(''),
                                          onTypeClick(item),
                                          showOverflow()
                                      }}
                                      onMouseOver={() => MouseOver(item && item.type)}
                                      onMouseOut={MouseOut}
                                    >
                                      <Highlighter
                                        className="mt-3 ml-4 text-xl text-gray-400 search-font"
                                        highlightClassName="relative text-white bg-inherit opacity-95 bg-opacity-20 font-normal text-xl"
                                        searchWords={[searchText]}
                                        autoEscape={true}
                                        textToHighlight={item && item.type}
                                      />
                                    </a>
                                  </div>
                                </div>
                              ))}

                            {suggestions?.CategoryList &&
                              suggestions?.CategoryList?.slice(0, 4).map((item, i) => (
                                <div key={i} className="flex md:gap-6">
                                  <div className="w-full text-xl font-thin leading-loose bg-black hover:bg-opacity-20 hover:bg-gray-200 ">
                                    <a
                                      className="cursor-pointer"
                                      onClick={() => {
                                        dispatch(
                                          setFilters({
                                            categories: [item?.id],
                                            searchQuery: '',
                                            types: null,
                                            profileCategory: null,
                                            relatedSpeakers: null,
                                            sortOrder: null,
                                          })
                                        ),
                                          setIsPopup(false)
                                        setSearchText(''),
                                          setViewText(''),
                                          onCategoryClick(item),
                                          showOverflow()
                                      }}
                                      onMouseOver={() => MouseOver(item && item.category)}
                                      onMouseOut={MouseOut}
                                    >
                                      <Highlighter
                                        className="mt-3 ml-4 text-xl text-gray-400 search-font"
                                        highlightClassName="relative text-white bg-inherit opacity-95 bg-opacity-20 font-normal text-xl"
                                        searchWords={[searchText]}
                                        autoEscape={true}
                                        textToHighlight={item && item.category}
                                      />
                                    </a>
                                  </div>
                                </div>
                              ))}

                            {suggestions?.NameList &&
                              suggestions?.NameList?.slice(0, 4).map((item, i) =>
                                item && item.image_url ? (
                                  <div key={i} className="z-0 flex md:gap-6">
                                    <div className="w-full bg-black cursor-pointer hover:bg-opacity-20 hover:bg-gray-200">
                                      <Link
                                        href={`/speaker/${item?.slug}`}
                                        className="cursor-pointer"
                                        legacyBehavior
                                      >
                                        <a
                                          onClick={() => {
                                            setIsPopup(false),
                                              setSearchText(''),
                                              setViewText(''),
                                              showOverflow()
                                          }}
                                          onMouseOver={() => MouseOver(item?.name)}
                                          onMouseOut={MouseOut}
                                        >
                                          <div className="flex my-2">
                                            <img
                                              height={50}
                                              width={50}
                                              objectFit="cover"
                                              objectPosition="top"
                                              src={
                                                item &&
                                                'https:' +
                                                  item?.image_url +
                                                  '?w=500&h=500&q=100&fit=thumb&f=top'
                                              }
                                              alt="speaker"
                                            ></img>
                                            <Highlighter
                                              className="mt-4 ml-4 text-xl font-light text-gray-400 search-font"
                                              highlightClassName="relative text-white bg-inherit opacity-95 bg-opacity-20 font-normal text-xl"
                                              searchWords={[searchText]}
                                              autoEscape={true}
                                              textToHighlight={item?.name}
                                            />
                                          </div>
                                        </a>
                                      </Link>
                                    </div>
                                  </div>
                                ) : (
                                  <div key={i}></div>
                                )
                              )}
                          </div>
                        )}
                      </>
                    ) : (
                      <div>
                        <div className="px-4 mb-24">
                          <li className="py-3 text-lg font-medium leading-6 text-white list-none">
                            <AuthenticatedTemplate>
                              <Link href="/myAccount" legacyBehavior>
                                <a
                                  onClick={() => {
                                    setIsPopup(false)
                                    showOverflow()
                                  }}
                                >
                                  <button>
                                    <MyProfile userName="My Account" />
                                  </button>
                                </a>
                              </Link>
                            </AuthenticatedTemplate>
                          </li>
                          <li className="py-3 text-lg font-medium leading-6 text-white list-none">
                            <Link href="/book-now" legacyBehavior>
                              <a
                                onClick={() => {
                                  setIsPopup(false)
                                  showOverflow()
                                }}
                              >
                                Book Now
                              </a>
                            </Link>
                          </li>
                          {mobileViewMenu.map((item, index) => (
                            <li
                              key={index}
                              className="py-3 text-lg font-medium leading-6 text-white list-none "
                            >
                              {!item.isLink ? (
                                <>
                                  <Link
                                    href="tel:+1 (212) 645-4200"
                                    className="sm:hidden"
                                    legacyBehavior
                                  >
                                    <a
                                      className="no-underline hover:underline sm:hidden"
                                      target={item.target || '_blank'}
                                    >
                                      {item.name}
                                    </a>
                                  </Link>
                                  <div className="py-3 hidden sm:block">{item.name}</div>
                                </>
                              ) : item.url ? (
                                <Link href={item.url} legacyBehavior>
                                  <a target="_blank">{item.name}</a>
                                </Link>
                              ) : (
                                <Link scroll={false} href={''} legacyBehavior>
                                  <a
                                    className={item.isChat && 'cursor-pointer'}
                                    onClick={() => {
                                      item.isChat && toggleChat()
                                      setIsChatOpen(true)
                                    }}
                                  >
                                    <div>{item.name}</div>
                                  </a>
                                </Link>
                              )}
                            </li>
                          ))}
                          <li className="py-3 text-lg font-medium leading-6 text-white list-none">
                            <Link href="/contact" legacyBehavior>
                              <a
                                onClick={() => {
                                  setIsPopup(false)
                                  showOverflow()
                                }}
                              >
                                Get In Contact
                              </a>
                            </Link>
                          </li>
                        </div>

                        <UnauthenticatedTemplate>
                          <Button
                            className="flex justify-center w-full py-3 text-sm font-extrabold tracking-wider bg-black border tagline-font button-hover"
                            label="Login"
                            handleClick={() => instance?.loginRedirect()}
                          />
                        </UnauthenticatedTemplate>
                        <AuthenticatedTemplate>
                          <Button
                            className="flex justify-center w-full py-3 mb-4 text-sm font-extrabold tracking-wider bg-black border tagline-font button-hover"
                            label="Sign Out"
                            handleClick={handleSignout}
                          />
                        </AuthenticatedTemplate>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          }
          handleClose={() => {
            setIsPopup(false)
            showOverflow()
            setSearchText('')
            setError('Enter at least 2 characters to search')
          }}
        />
      )}
    </div>
  )
}

export default HeaderMobileView

const mobileViewMenu = [
  { name: 'About UTA', url: 'https://www.unitedtalent.com/about/', isLink: true },
  { name: 'Call Us: (212) 645-4200', url: null, isLink: false },
  { name: 'Chat Now', url: null, isChat: true, isLink: true },
]
